import { initSentry } from "./lib/sentry";

// Initialize Sentry as early as possible so it can catch errors thrown
// during module evaluation in App and its children. No-op when
// VITE_SENTRY_DSN is not set.
initSentry();


import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
